import { API_POST, DBRequest } from '../../api/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function subscribeForPush(config, publicVapidKey, alreadyGranted) {
  // 1. Ask for permission
  if (!alreadyGranted) {
    if (!('Notification' in window)) {
      return 'denied';
    }
    const permission = await Notification?.requestPermission();

    if (permission !== 'granted') return 'denied';
  }
  // 2. Register service worker
  await navigator.serviceWorker.register('/service-worker.js');

  const registration = await navigator.serviceWorker.ready;

  //Unsubscribe from existing subscriptions
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    await existingSubscription.unsubscribe();
    //console.log('Old subscription removed');
  }

  // 3. Subscribe using browser PushManager
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
  });

  const supportedEncodings = PushManager.supportedContentEncodings;
  const usedEconding = supportedEncodings[supportedEncodings.length - 1];

  return new Promise((resolve, reject) => {
    DBRequest({
      config,
      path: 'web-push/subscribe',
      method: API_POST({
        ...subscription.toJSON(),
        contentEncoding: usedEconding,
      }),
      onResponse: (res) => {
        resolve('success');
      },
      onError: (error) => {
        reject('error');
      },
    });
  });
}

export async function unsubscribeFromPush(config) {
  // 1. Get the service worker registration
  const registration = await navigator?.serviceWorker?.ready;

  // 2. Get the existing subscription
  const subscription = await registration?.pushManager?.getSubscription();

  if (!subscription) {
    return 'no-subscription';
  }

  // 3. Unsubscribe in the browser
  await subscription?.unsubscribe();

  // 4. Notify backend to remove it
  return new Promise((resolve, reject) => {
    DBRequest({
      config,
      path: 'web-push/unsubscribe',
      method: API_POST(subscription), // send subscription info to delete on backend
      onResponse: (res) => {
        resolve('success');
      },
      onError: (error) => {
        reject('error');
      },
    });
  });
}
